import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 瑞典语
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Alla rättigheter förbehållna',
    },
    auth: {
        login: 'Logga in',
        username: 'Användarnamn',
        username_placeholder: 'Ange användarnamn',
        password: 'Lösenord',
        password_placeholder: 'Ange lösenord',
        code: 'Verifieringskod',
        code_placeholder: 'Ange verifieringskod',
        logout: 'Logga ut',
        logout_success: 'Du har loggats ut',
        day: 'dag',
        password_expiration: 'Lösenordets giltighet har gått ut – vänligen ändra det',
        expire: 'Återstående tid till lösenordsutgång',
        conseils:
            'Måste innehålla versaler, gemener, siffror och specialtecken ({msg}). Lösenordslängden måste vara mellan 8 och 16 tecken.',
        brand_Selection: 'Varumärkesval',
        unread_notices: 'Olästa meddelanden',
        new_cases: 'Nya ärenden',
        unanswered_cases: 'Obesvarade ärenden',
        overdue_cases: 'Försenade ärenden',
    },
    button: {
        query: 'Sök',
        editing_position: 'Redigera position',
        show_theme_editor: 'Visa/dölj temaredigerare',
        change_password: 'Ändra lösenord',
        old_password: 'Gammalt lösenord',
        new_password: 'Nytt lösenord',
        confirm_password: 'Bekräfta lösenord',
        button: 'Knapp',
        about: 'Om',
        back: 'Tillbaka',
        go: 'OK',
        home: 'Hem',
        confirm: 'Bekräfta',
        modify: 'Ändra',
        edit: 'Redigera',
        new: 'Ny',
        cancel: 'Avbryt',
        close: 'Stäng',
        search: 'Sök',
        reset: 'Återställ',
        delete: 'Radera',
        add: 'Lägg till',
        collapse: 'Minimera',
        expand: 'Expandera',
        download_template: 'Ladda ner mall',
        batch_import: 'Massimport',
        import: 'Importera',
        export: 'Exportera',
        export_fail: 'Import misslyckades',
        detailed: 'Detaljerad',
        details: 'Detaljer',
        download: 'Ladda ner',
        toView: 'Visa',
        toViews: 'Visa bilder',
        uploadAttachments: 'Ladda upp bilagor',
        selectFile: 'Välj fil',
        fillingInstructions: 'Instruktioner för ifyllning',
        release: 'Publicera',
        release_recall: 'Återkalla publicering',
        save: 'Spara',
        send: 'Skicka',
        tips: 'Tips',
        send_back: 'Skicka tillbaka',
        examine: 'Granska',
        void: 'Ogiltigförklara',
        more: 'Mer',
        refresh: 'Uppdatera',
        selects: 'Välj',
        serial_number: 'Serienummer',
        upload_progress: 'Uppladdningsförlopp',
        invalid: 'Ogiltigt',
        daily_record: 'Daglig rapport',
        operation_type: 'Åtgärdstyp',
        field_name: 'Fältnamn',
        edit_role: 'Redigera roll',
        user_role: 'Välj roll',
        assignment_role: 'Roll',
        post: 'Position',
        sending: 'Skickar...',
        reset_password: 'Återställ lösenord',
        display_or_not: 'Visa eller inte',
        document: 'Dokument',
        specificTemplates: 'Specifika mallar',
        transferOrder: 'Överför order',
        forwarding: 'Vidarebefordra',
        one_click_notification: 'Avisering med ett klick',
        english_export: 'Exportera på engelska',
        oneclick_download: 'Nedladdning med ett klick',
        passwordmsga: 'Måste innehålla versaler, gemener, siffror och specialtecken (@\\$!_~\\&*)',
        passwordmsgb: 'Lösenordslängden måste vara mellan 8 och 16 tecken',
        passwordmsgc: 'Får inte vara identiskt med något av de senaste sex lösenorden',
        export_file_list: 'Lista över exporterade filer',
        personal_center: 'Personligt centrum',
        upload_list: 'Uppladdningslista',
        clear_completed: 'Rensa slutförda',
    },
    radio: {
        enabled: 'Aktiverad',
        disabled: 'Inaktiverad',
        catalogue: 'Katalog',
        individual: 'Individuell',
        all: 'Alla',
        yes: 'Ja',
        no: 'Nej',
    },
    dropdown: {
        close_others: 'Stäng andra',
        close_right: 'Stäng till höger',
        close_left: 'Stäng till vänster',
    },
    table: {
        action: 'Åtgärd',
        explain: 'Förklaring',
        fileName: 'Filnamn',
        size: 'Storlek (MB)',
        uploader: 'Uppladdad av',
        uploadTime: 'Uppladdningsdatum',
        system: 'System',
        caption: 'Rubrik',
        categorization: 'Kategorisering',
        link: 'Länk',
        forwarding_time: 'Vidarebefordringsdatum',
        forwarder: 'Vidarebefordrad av',
        send_to: 'Skicka till',
        mode: 'Läge',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `Sida ${named('number')}`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Totalt ${named('number')} poster`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `Totalt ${named('number')} fordon`,
    },
    confirm: {
        confirm_deletion: 'Bekräfta borttagning?',
        confirm_void: 'Bekräfta ogiltigförklaring?',
        confirm_release: 'Bekräfta publicering?',
        ack: 'Bekräfta',
        cancel: 'Avbryt',
        non_records: 'Välj minst en post',
    },
    request: {
        failed_placeholder: 'Begäran misslyckades – serverfel',
        success_placeholder: 'Begäran lyckades',
        auth: {
            login_success: 'Inloggning lyckades',
        },
        error: {
            '404': 'Resursen hittades inte',
            '403': 'Otillräckliga behörigheter',
        },
    },
    page: {
        global: {
            page_search: 'Sök på sidan',
        },
        error: {
            not_found: 'Sidan hittades inte',
            not_found_des: 'Ingenting här',
            auth_failed: 'Otillräckliga behörigheter',
            auth_failed_des: 'Denna sida är förbjuden',
            file_format_error: 'Ogiltigt filformat!',
            preview_failed: 'Förhandsgranskning misslyckades! Filen är skadad!',
        },
        homepage: {
            homepage: homepage.homepage.svSE,
        },
        system: {
            menu: system.menu.svSE,
            dict: system.dict.svSE,
            dept: system.dept.svSE,
            role: system.role.svSE,
            user: system.user.svSE,
        },
        info: {
            announcement: Info.announcement.announcement.svSE,
            document: Info.document.document.svSE,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.svSE,
                recallActivity: tech.quality.recallActivity.svSE,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.svSE,
            },
            management: {
                inquiryOd: tech.management.inquiry.svSE,
                permission: tech.management.permission.svSE,
                onSiteSupportHq: tech.management.onSiteSupport.svSE,
                progHistoryHq: tech.management.progHistory.svSE,
                salesRecordHq: tech.management.salesRecord.svSE,
                vehicleInfoHq: tech.management.vehicleInfo.svSE,
                claimHq: tech.management.claim.svSE,
                filterHq: tech.management.filter.svSE,
                newCarlssue: tech.management.newCarIssue.svSE,
                newCarDefinition: tech.management.newCarDefinition.svSE,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.svSE,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.svSE,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.svSE,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.svSE,
        },
        statistics: statistics.inquiryStatistics.svSE,
        systemClassifyA: statistics.systemClassifyA.svSE,
        systemClassifyB: statistics.systemClassifyB.svSE,
        engineerStatistics: statistics.engineerStatistics.svSE,
        defectivePart: statistics.defectivePart.svSE,
        replyInquiryStatistics: statistics.replyInquiryStatistics.svSE,
        passRateStatistics: statistics.passRateStatistics.svSE,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.svSE,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.svSE,
        customsClearance135Rate: statistics.customsClearance135Rate.svSE,
        accumulatedClosureRate: statistics.accumulatedClosureRate.svSE,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.svSE,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.svSE,
    },
    validation: {
        common: {
            required: 'Detta fält är obligatoriskt',
            numeric: 'Måste vara ett heltal',
            decimal: 'Måste vara ett tal',
            positive_interger: 'Måste vara ett positivt heltal',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maximalt ${named('number')} siffror`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maximalt ${named('number')} tecken tillåtna`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maximalt antal tecken överskridet (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Måste innehålla minst ${named('number')} tecken`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Måste innehålla exakt ${named('number')} tecken`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Får inte vara större än ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Får inte vara mindre än ${named('number')}`,
            up_to_2_decimal_places: 'Maximalt två decimaler',
            retain_up: 'Maximalt 10 siffror före decimaltecknet och 2 efter',
            retain_ups: 'Maximalt 11 siffror före decimaltecknet och 4 efter',
            input_number: 'Ange endast arabiska siffror',
            only_number_a: 'Endast bokstäver eller siffror tillåtna',
            translate: 'Endast bokstäver tillåtna',
            positive_integer: 'Fyll i minst ett fält',
            at_least_one: 'Fyll i minst ett',
        },
        tip: {
            incomplete_information: 'Ofullständig information',
        },
    },
    import: {
        template_file: 'Mallfil',
        browse: 'Bläddra',
        download_template: 'Ladda ner mall',
        no_file_selected: 'Ingen fil vald',
        incorrect_file_type: 'Felaktig filtyp',
        exceed: 'Gräns överskriden',
        upload_success: 'Uppladdning lyckades',
        upload_fail: 'Uppladdning misslyckades',
        again_upload:
            'Endast bilder i formaten jpg, png, bmp eller gif kan laddas upp. Försök igen.',
        attachmentUpload: 'Ladda upp bilagor',
        otherAttachmentUpload: 'Ladda upp andra bilagor',
        supportedFormats: 'Godkända format',
        preview: 'Förhandsgranska',
    },
    export: {
        noDataToExport: 'Ingen data att exportera',
    },
    select: {
        all: 'Alla',
    },
    checkbox: {
        select_all: 'Markera alla',
    },
    dialog: {
        error_message: 'Felmeddelande',
        one_year: 'Du kan exportera högst ett års data åt gången',
    },
    ymd: {
        year: 'år',
        month: 'månad',
        day: 'dag',
        week: 'vecka',
        january: 'Januari',
        february: 'Februari',
        march: 'Mars',
        april: 'April',
        may: 'Maj',
        june: 'Juni',
        july: 'Juli',
        august: 'Augusti',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'December',
    },
};
